(function ( $ ) {

    $(document).ready(function () {

        var counter = 50;
        $('.brand-mediatext').each(function () {
            // to make each of Brand Media text blocks have larger z-index than lower Brand Media text block
            $(this).css('z-index', counter--);
        });

        var $curSlantedImg;

        $('.brand-mediatext .range-slider').on('input',function (e) {
            var $this = $(this);
            var curVal = $this.val() + '%';

            $this.siblings('.cur-value').html( curVal ); // updating .badge element value for current range-slider

            if ( typeof e.originalEvent !== "undefined" ) {
                // check if event was native ( in another words - was NOT triggered by some js code)

                $curSlantedImg = $this.closest('.image-position').siblings('.slanted-wrapper').find('.slanted-image'); // getting slanted-image for current range-sliders
                console.log($curSlantedImg);
                if ( $this.hasClass('size') ) { // updating width css property for bg-image
                    $curSlantedImg.css('width', curVal);
                }
                else if ( $this.hasClass('x-pos') ) { // updating right css property for bg-image
                    $curSlantedImg.css('right', curVal);
                }
                else if ( $this.hasClass('y-pos') ) { // updating bottom css property for bg-image
                    $curSlantedImg.css('bottom', curVal);
                }
            }
        });

    });
})( jQuery )
